// react
import React, { FormEvent } from "react";

import Spacer from "../../../Spacer";
// styles
import css from "../../Modal.module.scss";
import ContentModal, { ContentModalProps } from "../ContentModal";

/*
    This template wraps the Content Modal to provide Form functionality to the modal.
    It does this by moving the buttons to be within a form so that a submit button can be added
*/

interface FormModalProps extends ContentModalProps {
	/**
	 * runs when the form is submitted
	 */
	onSubmit?: (event: FormEvent<HTMLFormElement>) => void;

	/**
	 * form id and test id
	 */
	id?: string;
}

export const FormModal = (props: FormModalProps) => {
	const {
		buttons = null,
		title = null,
		handleClose,
		size = "auto",
		contentClassName,
		wrapperClassName,
		isOpen = true,
		children = null,
		closeOnClickOutside = true,
		onSubmit = () => {},
		id = "form-modal",
		hideCloseButton = false,
	} = props;

	return (
		<ContentModal
			isOpen={isOpen}
			size={size}
			wrapperClassName={wrapperClassName}
			handleClose={handleClose}
			closeOnClickOutside={closeOnClickOutside}
			title={title}
			hideCloseButton={hideCloseButton}
		>
			<form onSubmit={onSubmit} id={id} data-testid={id}>
				<div data-testid="modalContent" className={contentClassName || css.innerModalContent}>
					{children}
				</div>

				{buttons && (
					<div>
						<Spacer height={3} />
						<div data-testid="modalButtons" className={`${css.modalButtons} ${css.contentModalButtons}`}>
							{buttons.map((button) => button)}
						</div>
					</div>
				)}
			</form>
		</ContentModal>
	);
};

export default FormModal;
